// Renders a string with **bold** markers as <strong> elements
export const RichText = ({ text }) => {
  const parts = String(text).split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? (
      <strong key={i} className="font-semibold text-[#1A1528]">{part.slice(2, -2)}</strong>
    ) : (
      part
    )
  );
};
